import styled from "styled-components";
import { LayoutConst } from "../../../core";
import { Colors } from "@brg/ui";

export const TransferModalBody = styled.div`
  display: flex;
  flex-direction: column;
  background: #FEFEFE;
  width: 480px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  padding: 32px 40px 40px 40px;
  row-gap: 8px;

  @media (max-width: ${LayoutConst.screen.l_12}px) {
    padding: 16px 20px 20px 20px;
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    width: 100vw;
    border-radius: 8px 8px 0 0;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.12);
    padding: 16px 16px 40px 16px;
  }
`;

export const TransferModalBodyStep1 = styled(TransferModalBody)`
  width: 720px;
  height: 332px;
  min-height: 332px;
  background-color: ${p => p.theme.commonCheckbox.bg};
  
  @media (max-width: ${LayoutConst.screen.l_12}px) {
    width: 550px;
    height: 280px;
    min-height: 280px;
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    width: 100vw;
    height: auto;
    min-height: auto;
  }
    
`;

export const TransferModalBodyLink = styled(TransferModalBody)`
  width: 720px;
  background-color: ${p => p.theme.commonCheckbox.bg};
  
  @media (max-width: ${LayoutConst.screen.l_12}px) {
    width: 550px;
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    width: 100vw;
  }
`;

export const CloseModalIconWrapper = styled.div`
  position: absolute;
  right: 0;
  cursor: pointer;

  &:hover {
    svg path {
      fill: ${({ theme }) => theme.subscribeInfo.hover};
    }
  }
`;

export const TransferModalHeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
`;

export const TransferModalTitleBreadcrumb = styled.span`
  font-family: "Inter";
  font-weight: 700;
  font-size: 28px;
  line-height: 34px;
  letter-spacing: -0.02em;
  color: ${({ theme }) => theme.app.text};
  margin-right: 16px;

  @media(max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 23px;
    line-height: 27px;
  }

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: 17px;
    line-height: 22px;
  }
`;

export const TransferModalTitleMain = styled.span`
  font-family: "Inter";
  font-weight: 700;
  font-size: 28px;
  line-height: 34px;
  letter-spacing: -0.02em;
  color: ${({ theme }) => theme.app.text};

  @media(max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 23px;
    line-height: 27px;
  }

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: 17px;
    line-height: 22px;
  }
`;

export const TransferModalDescription = styled.p`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 17px;
  line-height: 22px;
  letter-spacing: -0.02em;
  color: ${p => p.theme.not_saved_modal.channelTitle || '#151514'};
  margin: 0;
  text-align: left;

  @media (max-width: ${LayoutConst.screen.l}px) {
    font-size: 14px;
    line-height: 18px;
  }
`;

export const TransferModalButtonsRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 24px;
  margin-top: 8px;
  
  @media (max-width: ${LayoutConst.screen.s}px) {
    gap: 8px;
  }
`;

export const TransferModalButtonsRowStep1 = styled(TransferModalButtonsRow)`
  margin-top: auto;
    
  @media (max-width: ${LayoutConst.screen.s}px) {
    margin-top: 72px;
    flex-direction: column;
  }
`;

export const TransferLinkInputWrapper = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

export const TransferLinkInputWrapperAtBottom = styled(TransferLinkInputWrapper)`
  margin-top: auto;
`;

export const TransferLinkInput = styled.input`
  flex: 1;
  padding: 12px 16px;
  background: #F2F2F2;
  border: 1px solid transparent;
  border-radius: 3px;
  font-family: "Inter";
  font-size: 13px;
  line-height: 16px;
  color: #151514;

  &::placeholder {
    color: #909090;
  }

  &:read-only {
    cursor: default;
  }
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  flex-shrink: 0;
  background-color: ${Colors.galBlack47};
  margin: 8px 0;
`;

export const InstructionsList = styled.ol`
  list-style: decimal;
  padding-left: 20px;
  margin: 0;
`;

export const BottomGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

import styled from "styled-components";
import { LayoutConst } from "../../../core";
import { Colors } from "@brg/ui";

export const TransferModalBody = styled.div`
  display: flex;
  flex-direction: column;
  background: #FEFEFE;
  width: 480px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  padding: 32px 40px 40px 40px;
  row-gap: 8px;

  @media (max-width: ${LayoutConst.screen.l_12}px) {
    padding: 16px 20px 20px 20px;
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    width: 100vw;
    border-radius: 8px 8px 0 0;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.12);
    padding: 16px 16px 40px 16px;
  }
`;

export const TransferModalBodyStep1 = styled(TransferModalBody)`
  width: 720px;
  height: 332px;
  min-height: 332px;
  background-color: ${p => p.theme.commonCheckbox.bg};
  
  @media (max-width: ${LayoutConst.screen.l_12}px) {
    width: 550px;
    height: 280px;
    min-height: 280px;
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    width: 100vw;
    height: auto;
    min-height: auto;
  }
    
`;

export const TransferModalBodyLink = styled(TransferModalBody)`
  width: 720px;
  background-color: ${p => p.theme.commonCheckbox.bg};
  
  @media (max-width: ${LayoutConst.screen.l_12}px) {
    width: 550px;
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    width: 100vw;
  }
`;

export const CloseModalIconWrapper = styled.div`
  position: absolute;
  right: 0;
  cursor: pointer;

  &:hover {
    svg path {
      fill: ${({ theme }) => theme.subscribeInfo.hover};
    }
  }
`;

export const TransferModalHeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
`;

export const TransferModalTitleBreadcrumb = styled.span`
  font-family: "Inter";
  font-weight: 700;
  font-size: 28px;
  line-height: 34px;
  letter-spacing: -0.02em;
  color: ${({ theme }) => theme.app.text};
  margin-right: 16px;

  @media(max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 23px;
    line-height: 27px;
  }

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: 17px;
    line-height: 22px;
  }
`;

export const TransferModalTitleMain = styled.span`
  font-family: "Inter";
  font-weight: 700;
  font-size: 28px;
  line-height: 34px;
  letter-spacing: -0.02em;
  color: ${({ theme }) => theme.app.text};

  @media(max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 23px;
    line-height: 27px;
  }

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: 17px;
    line-height: 22px;
  }
`;

export const TransferModalDescription = styled.p`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 17px;
  line-height: 22px;
  letter-spacing: -0.02em;
  color: ${p => p.theme.not_saved_modal.channelTitle || '#151514'};
  margin: 0;
  text-align: left;

  @media (max-width: ${LayoutConst.screen.l}px) {
    font-size: 14px;
    line-height: 18px;
  }
`;

export const TransferModalButtonsRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 24px;
  margin-top: 8px;
  
  @media (max-width: ${LayoutConst.screen.s}px) {
    gap: 8px;
  }
`;

export const TransferModalButtonsRowStep1 = styled(TransferModalButtonsRow)`
  margin-top: auto;
    
  @media (max-width: ${LayoutConst.screen.s}px) {
    margin-top: 72px;
    flex-direction: column;
  }
`;

export const TransferLinkInputWrapper = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

export const TransferLinkInputWrapperAtBottom = styled(TransferLinkInputWrapper)`
  margin-top: auto;
`;

export const TransferLinkInput = styled.input`
  flex: 1;
  padding: 12px 16px;
  background: #F2F2F2;
  border: 1px solid transparent;
  border-radius: 3px;
  font-family: "Inter";
  font-size: 13px;
  line-height: 16px;
  color: #151514;

  &::placeholder {
    color: #909090;
  }

  &:read-only {
    cursor: default;
  }
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  flex-shrink: 0;
  background-color: ${Colors.galBlack47};
  margin: 8px 0;
`;

export const InstructionsList = styled.ol`
  list-style: decimal;
  padding-left: 20px;
  margin: 0;
`;

export const BottomGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

